import { c as _c } from "react/compiler-runtime";
import { Grid, Skeleton, Stack } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { CheckoutProductAside } from '../CheckoutProductAside';
import { useConversionProducts } from './useConversionProducts';
export type ConversionPaymentSummaryProps = {
  productId: string;
  termId?: string | null;
  couponCode?: string | null;
  /** The payment form (register / Stripe / submit) rendered beside the summary. */
  children: ReactNode;
};

/**
 * Full-page checkout layout: the live catalog summary of exactly what is being bought (due today,
 * renewal, trial, included lines) beside the payment form. Used by `/accelerator/payment`.
 */
export const ConversionPaymentSummary = t0 => {
  const $ = _c(22);
  const {
    children,
    couponCode,
    productId,
    termId
  } = t0;
  let t1;
  if ($[0] !== productId) {
    t1 = [productId];
    $[0] = productId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== couponCode || $[3] !== termId) {
    t2 = {
      termId,
      couponCode
    };
    $[2] = couponCode;
    $[3] = termId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    products,
    loading
  } = useConversionProducts(t1, t2);
  const product = products[0];
  let t3;
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      base: 0,
      md: "lg"
    };
    t4 = {
      base: 0,
      md: "1px"
    };
    t5 = {
      base: "none",
      md: "md"
    };
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      base: "1fr",
      md: "minmax(0, 0.9fr) minmax(0, 1.1fr)"
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      base: "1px",
      md: 0
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      base: 0,
      md: "1px"
    };
    t9 = {
      base: 5,
      md: 8
    };
    $[10] = t8;
    $[11] = t9;
  } else {
    t8 = $[10];
    t9 = $[11];
  }
  let t10;
  if ($[12] !== loading || $[13] !== product) {
    t10 = product ? <CheckoutProductAside assurance="Cancel anytime" product={product} variant="plain" /> : loading ? <Stack aria-label="Loading plan summary" gap={4}><Skeleton h={7} w="60%" /><Skeleton h={24} w="full" /><Skeleton h={40} w="full" /></Stack> : null;
    $[12] = loading;
    $[13] = product;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10) {
    t11 = <Stack bg="colorPalette.card/25" borderBottomWidth={t7} borderColor="colorPalette.border/33" borderEndWidth={t8} p={t9}>{t10}</Stack>;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== children) {
    t12 = <Stack>{children}</Stack>;
    $[17] = children;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = <Grid bg="colorPalette.container" borderColor="border" borderRadius={t3} borderWidth={t4} boxShadow={t5} gap={0} maxW="5xl" overflow="hidden" templateColumns={t6} w="full">{t11}{t12}</Grid>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
};